module.exports = __webpack_public_path__ + "media/audio40.957a9600.mp3";